import moment from 'moment';
import * as assetsService from '../services/assetService';
import {
    ASSETS_LOADING,  ADD_AUDIO_FOLDER, GET_AUDIO_FOLDER, EDIT_AUDIO_FOLDER, DELETE_AUDIO_FOLDER,
    ADD_AUDIO_FILE, GET_AUDIO_FILE, EDIT_AUDIO_FILE, DELETE_AUDIO_FILE,
    ADD_CLIP_FOLDER, GET_CLIP_FOLDER, EDIT_CLIP_FOLDER, DELETE_CLIP_FOLDER,
    ADD_CLIP_FILE, GET_CLIP_FILE, EDIT_CLIP_FILE, DELETE_CLIP_FILE,
} from '../reducers/assetsReducer';

export const getAudioFolder = (parent) => (dispatch) => {
  dispatch({type: ASSETS_LOADING, payload: true});
  assetsService.getAudioFolders(parent)
    .then(result => {
      dispatch({type: GET_AUDIO_FOLDER, payload: result.data});
    })
    .catch((error) => console.log(error))
    .finally(() => dispatch({type: ASSETS_LOADING, payload: false}));
}

export const getAudioAssetFile = (folderID) => (dispatch) => {
  dispatch({type: ASSETS_LOADING, payload: true});
  assetsService.getAudioAssetFile(folderID)
    .then(result => {
      dispatch({type: GET_AUDIO_FILE, payload: result.data});
    })
    .catch((error) => console.log(error))
    .finally(() => dispatch({type: ASSETS_LOADING, payload: false}));
}

export const addAudioAssetFile = (payload) => (dispatch) => new Promise((resolve, reject) => {
  dispatch({type: ASSETS_LOADING, payload: true});
  assetsService.addAudioAssetFile(payload)
    .then(result => {
      let {insertId: id} = result.data;
      dispatch({
        type: ADD_AUDIO_FILE,
        payload: {
          id,
          created: moment().format(),
          ...payload,
        }
      });
      resolve();
    })
    .catch((error) => reject(error))
    .finally(() => dispatch({type: ASSETS_LOADING, payload: false}));
});

export const addAudioFolder = (payload) => (dispatch) => new Promise((resolve, reject) => {
  dispatch({type: ASSETS_LOADING, payload: true});
  assetsService.addAudioFolder(payload)
    .then(result => {
      const {insertId: id} = result.data;
      dispatch({type: ADD_AUDIO_FOLDER, payload: {...payload, id, created: moment().format()}});
      resolve(id);
    })
    .catch((error) => reject(error))
    .finally(() => dispatch({type: ASSETS_LOADING, payload: false}));
});

export const editAssetFile = (data, type) => (dispatch) => new Promise((resolve, reject) => {
  dispatch({type: ASSETS_LOADING, payload: true});
  assetsService.editAssetFile(data)
    .then(result => {
      dispatch({type: type === 'audio' ? EDIT_AUDIO_FILE : EDIT_CLIP_FILE, payload: {...data}});
      resolve();
    })
    .catch((error) => reject(error))
    .finally(() => dispatch({type: ASSETS_LOADING, payload: false}));
});

export const deleteAssetFile = (id, type) => (dispatch) => new Promise((resolve, reject) => {
  dispatch({type: ASSETS_LOADING, payload: true});
  assetsService.deleteAssetFile(id)
    .then(result => {
      dispatch({type: type === 'audio' ? DELETE_AUDIO_FILE : DELETE_CLIP_FILE, payload: {id}});
      resolve();
    })
    .catch((error) => reject(error))
    .finally(() => dispatch({type: ASSETS_LOADING, payload: false}));
});

export const editAssetFolder = (data, type) => (dispatch) => new Promise((resolve, reject) => {
  dispatch({type: ASSETS_LOADING, payload: true});
  assetsService.editFolder(data)
    .then(result => {
      dispatch({type: type === 'audio' ? EDIT_AUDIO_FOLDER : EDIT_CLIP_FOLDER, payload: {...data}});
      resolve();
    })
    .catch((error) => reject(error))
    .finally(() => dispatch({type: ASSETS_LOADING, payload: false}));
});

export const deleteAssetFolder = (folders, type) => (dispatch) => new Promise((resolve, reject) => {
  dispatch({type: ASSETS_LOADING, payload: true});
  assetsService.removeFolder(folders)
    .then(result => {
      dispatch({type: type === 'audio' ? DELETE_AUDIO_FOLDER : DELETE_CLIP_FOLDER, payload: {folders}});
      resolve();
    })
    .catch((error) => reject(error))
    .finally(() => dispatch({type: ASSETS_LOADING, payload: false}));
});

export const getClipFolder = (parent) => (dispatch) => {
  dispatch({type: ASSETS_LOADING, payload: true});
  assetsService.getClipFolder(parent)
    .then(result => {
      dispatch({type: GET_CLIP_FOLDER, payload: result.data});
    })
    .catch((error) => console.log(error))
    .finally(() => dispatch({type: ASSETS_LOADING, payload: false}));
}

export const getClipAssetFile = (folderID) => (dispatch) => {
  dispatch({type: ASSETS_LOADING, payload: true});
  assetsService.getClipAssetFile(folderID)
    .then(result => {
      dispatch({type: GET_CLIP_FILE, payload: result.data});
    })
    .catch((error) => console.log(error))
    .finally(() => dispatch({type: ASSETS_LOADING, payload: false}));
}

export const addClipAssetFile = (payload) => (dispatch) => new Promise((resolve, reject) => {
  dispatch({type: ASSETS_LOADING, payload: true});
  assetsService.addClipAssetFile(payload)
    .then(result => {
      let {insertId: id} = result.data;
      dispatch({
        type: ADD_CLIP_FILE,
        payload: {
          id,
          created: moment().format(),
          ...payload,
        }
      });
      resolve();
    })
    .catch((error) => reject(error))
    .finally(() => dispatch({type: ASSETS_LOADING, payload: false}));
});

export const addClipFolder = (payload) => (dispatch) => new Promise((resolve, reject) => {
  dispatch({type: ASSETS_LOADING, payload: true});
  assetsService.addClipFolder(payload)
    .then(result => {
      const {insertId: id} = result.data;
      dispatch({type: ADD_CLIP_FOLDER, payload: {...payload, id, created: moment().format()}});
      resolve(id);
    })
    .catch((error) => reject(error))
    .finally(() => dispatch({type: ASSETS_LOADING, payload: false}));
});
